import React from "react";

const ChevronCompactUp = () => {
    return (
        <svg width="3em" height="3em" viewBox="0 0 16 16" className="bi bi-chevron-compact-up"
             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd"
                  d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z"/>
        </svg>
    );
};

export default ChevronCompactUp;